import React from "react";

import { TARGET_TYPE_LABELS } from "../constants";
import { ActivityDetailBody, DetailGroupHeading, DetailList } from "../styles";
import { ActivityRecordDetailProps } from "../types";
import {
  fieldLabelOf,
  formatAuditValue,
  lisbonTimestamp,
} from "../utils/describeRecord";

export const ActivityRecordDetail: React.FC<ActivityRecordDetailProps> = ({
  record,
}) => {
  const { id, changes, context, recordedBy, createdAt, targetType, targetId } =
    record;
  const changeEntries = Object.entries(changes);
  const contextEntries = Object.entries(context ?? {});
  const recorder = recordedBy
    ? `${recordedBy.name} · ${recordedBy.email}`
    : "Deleted admin";

  return (
    <ActivityDetailBody>
      <DetailList>
        {changeEntries.length > 0 && (
          <DetailGroupHeading>Changes</DetailGroupHeading>
        )}
        {changeEntries.map(([field, { from, to }]) => (
          <React.Fragment key={`change-${field}`}>
            <dt>{fieldLabelOf(field)}</dt>
            <dd>
              {formatAuditValue(from)} → {formatAuditValue(to)}
            </dd>
          </React.Fragment>
        ))}
        {contextEntries.length > 0 && (
          <DetailGroupHeading>Context</DetailGroupHeading>
        )}
        {contextEntries.map(([field, value]) => (
          <React.Fragment key={`context-${field}`}>
            <dt>{fieldLabelOf(field)}</dt>
            <dd>{formatAuditValue(value)}</dd>
          </React.Fragment>
        ))}
        <DetailGroupHeading>Record</DetailGroupHeading>
        <dt>Recorded by</dt>
        <dd>{recorder}</dd>
        <dt>Timestamp</dt>
        <dd>
          <time dateTime={createdAt}>{lisbonTimestamp(createdAt)}</time>
        </dd>
        <dt>Target</dt>
        <dd>
          {TARGET_TYPE_LABELS[targetType]} #{targetId}
        </dd>
        <dt>Record ID</dt>
        <dd>{id}</dd>
      </DetailList>
    </ActivityDetailBody>
  );
};
